interface Props {
  onApply: () => void;
}

export default function PartnerHero({ onApply }: Props) {
  return (
    <section className="relative pt-36 pb-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8282b8d9011904fcbc76426bd001edfe.jpg"
          alt="Partner with The Mommy Mingle"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-gray-900/80 via-gray-900/70 to-rose-900/55" />
      </div>

      <div className="relative w-full max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-8">
          <i className="ri-map-pin-2-line text-rose-300 text-sm"></i>
          <span className="text-white/80 text-xs font-bold tracking-widest uppercase">Gwinnett &amp; Surrounding Areas</span>
        </div>

        <h1 className="text-5xl md:text-6xl font-extrabold text-white leading-tight mb-6 tracking-tight">
          Partner With
          <span className="block text-rose-300 mt-1">The Mommy Mingle</span>
        </h1>

        <p className="text-white/80 text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          Get your business in front of local moms who are already looking for what you offer.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={onApply}
            className="px-9 py-3.5 bg-rose-500 text-white font-bold rounded-full hover:bg-rose-600 transition-colors whitespace-nowrap cursor-pointer text-sm"
          >
            Apply to Partner
          </button>
          <a
            href="#tiers"
            className="px-9 py-3.5 bg-white/10 text-white font-semibold rounded-full border border-white/30 hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer text-sm backdrop-blur-sm"
          >
            View Opportunities
          </a>
        </div>

        <p className="text-white/40 text-xs mt-10 tracking-wide">
          Trusted by local moms across Gwinnett and surrounding areas.
        </p>
      </div>
    </section>
  );
}
